'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var Tooltip = require('@material-ui/core/Tooltip');
var Typography = require('@material-ui/core/Typography');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Tooltip__default = /*#__PURE__*/_interopDefaultLegacy(Tooltip);
var Typography__default = /*#__PURE__*/_interopDefaultLegacy(Typography);

var Element = _ref => {
  var {
    attributes,
    children,
    element
  } = _ref;

  switch (element.type) {
    case 'block-quote':
      return /*#__PURE__*/React__namespace.createElement("blockquote", attributes, children);

    case 'bulleted-list':
      return /*#__PURE__*/React__namespace.createElement("ul", attributes, children);

    case 'heading-one':
      return /*#__PURE__*/React__namespace.createElement(Typography__default['default'], _rollupPluginBabelHelpers['extends']({
        variant: "h2",
        component: "h1"
      }, attributes), children);

    case 'heading-two':
      return /*#__PURE__*/React__namespace.createElement(Typography__default['default'], _rollupPluginBabelHelpers['extends']({
        variant: "h3",
        component: "h2"
      }, attributes), children);

    case 'list-item':
      return /*#__PURE__*/React__namespace.createElement("li", attributes, children);

    case 'numbered-list':
      return /*#__PURE__*/React__namespace.createElement("ol", attributes, children);

    case 'link':
      {
        var _children$0$props$par, _children$, _children$$props, _children$$props$pare;

        var url = (_children$0$props$par = (_children$ = children[0]) === null || _children$ === void 0 ? void 0 : (_children$$props = _children$.props) === null || _children$$props === void 0 ? void 0 : (_children$$props$pare = _children$$props.parent) === null || _children$$props$pare === void 0 ? void 0 : _children$$props$pare.url) !== null && _children$0$props$par !== void 0 ? _children$0$props$par : '';
        return /*#__PURE__*/React__namespace.createElement(Tooltip__default['default'], {
          title: url
        }, /*#__PURE__*/React__namespace.createElement("a", _rollupPluginBabelHelpers['extends']({}, attributes, {
          href: element.url
        }), children));
      }

    default:
      return /*#__PURE__*/React__namespace.createElement("p", attributes, children);
  }
};
Element.propTypes = {
  attributes: index.any,
  element: index.any,
  children: index.node
};

exports.Element = Element;
exports.default = Element;
